export default {
//   options: ['inline', 'fontSize', 'list', 'textAlign', 'link', 'image', 'remove', 'history'],
  options: ['inline', 'fontSize', 'list', 'textAlign', 'link', 'remove', 'history'],
  inline: {
      inDropdown: false,
      className: undefined,
      component: undefined,
      dropdownClassName: undefined,
      options: ['bold', 'italic', 'underline', 'strikethrough'],
  },
//   image: {
//       className: undefined,
//       component: undefined,
//       popupClassName: undefined,
//       urlEnabled: true,
//       uploadEnabled: true,
//       alignmentEnabled: true,
//       uploadCallback: (a) => {},
//       previewImage: true,
//       inputAccept: 'image/gif,image/jpeg,image/jpg,image/png,image/svg',
//       alt: { present: false, mandatory: false },
//       defaultSize: {
//           height: 'auto',
//           width: '350',
//       },
//   },
}
